import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Divider,
  TextField,
  CardMedia,
  Paper,
  IconButton,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { flagService } from "../../service";
import { ImageBaseUrl } from "../../config/api-config";
import LongCaseComponent from "./LongCaseComponent";

const FlaggedQuestions = () => {
  const [displayedQuestion, setDisplayedQuestion] = useState(null);
  const [flagData, setFlagData] = useState([]);
  const [imageIndex, setImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    flagService.getFullFlaggedQuestions().then((res) => {
      if (res.status) {
        setFlagData(res.data);
      }
      setLoading(false);
    });
  }, []);
  const handleCardClick = (question) => {
    setDisplayedQuestion(question);
  };

  const handleBackButtonClick = () => {
    setDisplayedQuestion(null);
  };
  const handleNextImage = () => {
    if (imageIndex < displayedQuestion?.image?.length - 1) {
      setImageIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <div>
      {/* <DrawerComponent id={'courseId'}  /> */}
      {displayedQuestion ? (
        <Paper sx={{ p: 1, mr: 32 }}>
          {/* <Divider sx={{ my: 2 }} /> */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "50%" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <IconButton onClick={handleBackButtonClick} sx={{ mb: 0 }}>
                  <ArrowBackIcon style={{ color: "#EB568F" }} />
                </IconButton>
              </div>
              <Typography variant="body1">
                {displayedQuestion.question}
              </Typography>
              {displayedQuestion?.questionType === "Longcase" ? (
                <>
                  <LongCaseComponent data={displayedQuestion} />
                </>
              ) : (
                <>
                  <TextField
                    // select
                    label="Correct Answer"
                    value={displayedQuestion?.radAnswer || ""}
                    // onChange={(e) => setQuestionType(e.target.value)}
                    sx={{ width: "300px", mt: 2, color: "black" }}
                    // disabled
                  >
                    {/* <MenuItem   disabled>
                  Select Normal/Abnormal
                </MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Abnormal">Abnormal</MenuItem> */}
                  </TextField>
                  {displayedQuestion?.radAnswer === "Abnormal" && (
                    <TextField
                      label="Reason for Abnormal"
                      value={displayedQuestion?.radReason || ""}
                      // onChange={(e) => setAbnormalReason(e.target.value)}
                      multiline
                      rows={5}
                      sx={{ mt: 3, width: "500px" }}
                      // disabled
                    />
                  )}
                </>
              )}
            </div>
            <Card
              sx={{
                width: "50%",
                height: "50%",
                paddingTop: "52.25%", // 16:9 aspect ratio
                position: "relative",
              }}
            >
              <CardMedia
                component="div"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                }}
              >
                <div
                  className="pan-zoom-container"
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ReactPanZoom
                    image={`${ImageBaseUrl}${displayedQuestion?.image?.[imageIndex]}`}
                    alt={`Question`}
                  />
                </div>
              </CardMedia>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                {imageIndex > 0 && (
                  <Button
                    // variant="outlined"
                    color="primary"
                    sx={{ backgroundColor: "#ffff" }}
                    onClick={() => setImageIndex((prevIndex) => prevIndex - 1)}
                  >
                    Previous Image
                  </Button>
                )}

                {imageIndex < displayedQuestion?.image?.length - 1 && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleNextImage}
                    sx={{ ml: 2 }}
                  >
                    Next Image
                  </Button>
                )}
              </Box>
            </Card>
          </div>
        </Paper>
      ) : (
        <div>
          <Typography variant="h5" sx={{ color: "#666666", mb: 2 }}>
            Flagged Questions
          </Typography>
          {flagData?.length ? (
            flagData.map((question, index) => (
              <Card
                key={index}
                sx={{
                  mt: 2,
                  width: "38%",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "box-shadow 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                  },
                  cursor: "pointer",
                  borderRadius: "20px",
                  bgcolor: "rgba(211, 211, 211, 0.3)",
                }}
                onClick={() => handleCardClick(question)}
              >
                <CardContent sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography sx={{ fontSize: "20px" }}>
                    {`${question.examName}> ${question.questionType}`}
                  </Typography>

                  <Typography variant="body1">
                    Question {index + 1}: {question.question}{" "}
                    {/* Add index number */}
                  </Typography>
                </CardContent>
                <Divider />
              </Card>
            ))
          ) : loading ? (
            <CircularProgress sx={{mt:3}} />
          ) : (
            <Typography>No Record Found</Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default FlaggedQuestions;
